
// outsource dependencies
import _ from 'lodash';
import { toastr } from 'react-redux-toastr';
import { create } from 'redux-saga-controller';
import { takeEvery, put, call, select } from 'redux-saga/effects';

// local dependencies
import { COMMENTS, APP_TITLE } from '../../constant';
import { instanceAPI, SweetAlert } from '../../services';

// configure
export const commentsListCtrl = create({
  prefix: 'comments-list',
  actions: {
    initialize: 'INITIALIZE',
    deleteItem: 'DELETE_ITEM',
    updateFilter: 'UPDATE_FILTER',
  },
  initial: {
    list: [],
    disabled: false,
    initialized: false,
    errorMessage: null,
    // filter
    page: 0,
    size: 10,
    search: '',
    sortD: false,
    totalPages: 0,
    sortF: 'like',
  },
  subscriber: function * () {
    yield takeEvery(commentsListCtrl.action.initialize.TYPE, initializeSaga);
    yield takeEvery(commentsListCtrl.action.deleteItem.TYPE, deleteItemSaga);
    yield takeEvery(commentsListCtrl.action.updateFilter.TYPE, updateFilterSaga);
  }
});

function * initializeSaga () {
  yield put(commentsListCtrl.action.clearCtrl());
  const query = yield call(COMMENTS.QUERY);
  yield call(updateFilterSaga, { payload: { ...query } });
  yield put(commentsListCtrl.action.updateCtrl({ initialized: true }));
}

function * updateFilterSaga ({ payload }) {
  yield put(commentsListCtrl.action.updateCtrl({ ...payload, disabled: true }));
  try {
    const { page, search, size, sortF, sortD, } = yield select(commentsListCtrl.select);
    // TODO Wait BE implementation
    const { content, totalPages, pageNumber } = yield call(instanceAPI, {
      method: 'POST',
      data: { search },
      url: 'post/feed',
      params: { size, page, sort: [`${sortF},${sortD ? 'DESC' : 'ASC'}`] }
    });
    yield put(commentsListCtrl.action.updateCtrl({ list: _.uniqBy(content, 'id'), totalPages, page: pageNumber }));
    const latest = yield select(commentsListCtrl.select);
    yield call(COMMENTS.REPLACE, {}, latest);
  } catch ({ message }) {
    yield put(commentsListCtrl.action.updateCtrl({ errorMessage: message }));
  }
  yield put(commentsListCtrl.action.updateCtrl({ disabled: false }));
}

function * deleteItemSaga ({ payload }) {
  const id = _.get(payload, 'id');
  const comment = _.get(payload, 'comment');
  try {
    const confirmation = yield call(SweetAlert.confirm, {
      title: `Are you sure you want to delete comment: ${comment}?`
    });
    if (!confirmation.value) { return; }
    yield put(commentsListCtrl.action.updateCtrl({ disabled: true }));
    // TODO wait BE implementation
    yield call(instanceAPI, { method: 'DELETE', url: '/comments', data: [id] });
    yield call(toastr.success, APP_TITLE, 'Comment successfully deleted!');
    yield put(commentsListCtrl.action.initialize({}));
  } catch ({ message }) {
    yield call(SweetAlert.error, { title: message });
  }
  yield put(commentsListCtrl.action.updateCtrl({ disabled: false }));
}
